<template>
    <v-card
        outlined
        :disabled="loading || on_create"
        :loading="loading || on_create"
    >
        <v-card-title><v-icon>mdi-plus</v-icon> เพิ่มวันหยุดหวย</v-card-title>
        <v-form @submit="createLottoHoliday">
            <v-card-text>
                <v-date-picker
                    full-width
                    locale="th"
                    v-model="holiday_date"
                    elevation="5"
                ></v-date-picker>
                <v-select
                    :loading="loading"
                    :items="categories"
                    :disabled="loading || on_create"
                    class="mt-3"
                    item-value="id"
                    item-text="name"
                    label="หมวดหมู่หวย"
                    @change="selectCategory"
                ></v-select>
            </v-card-text>
            <v-card-actions class="mt-0 pt-0 mb-2">
                <v-btn
                    type="submit"
                    class="d-bock mx-auto"
                    color="primary"
                    :disabled="!category || on_create"
                    >เพิ่มวันหยุด</v-btn
                >
            </v-card-actions>
        </v-form>
    </v-card>
</template>
<script>
import moment from "moment-timezone";
export default {
    props: {
        loading: Boolean,
        categories: Array,
    },
    data: () => {
        return {
            on_create: false,
            category: null,
            holiday_date: moment().format("YYYY-MM-DD"),
        };
    },
    methods: {
        selectCategory(cate_id) {
            this.category = cate_id;
        },
        async createLottoHoliday($e) {
            $e.preventDefault();
            this.on_create = true;
            try {
                const data = await this.$store.dispatch(
                    "lottoHolidays/createHoliday",
                    {
                        id: this.category,
                        date: this.holiday_date,
                    }
                );
                if (data.success) {
                    this.$notify({
                        type: "success",
                        title: "สำเร็จ",
                        text: "เพิ่มวันหยุดหวยเรียบร้อย",
                    });
                    this.$emit("createSuccess", {
                        cate_id: this.category,
                    });
                } else if (!data.success && data.message) {
                    this.$notify({
                        type: "error",
                        title: "ล้มเหลว",
                        text: data.message,
                    });
                } else {
                    this.$notify({
                        type: "error",
                        title: "ล้มเหลว",
                        text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
                    });
                }
            } catch (err) {
                const errMsg =
                    (err &&
                        err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                    err.message ||
                    "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
                this.$notify({
                    type: "error",
                    title: "Error",
                    text: errMsg,
                });
            }

            this.on_create = false;
        },
    },
};
</script>
